import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { api } from "./api";

export type ErrorType<Error> = AxiosError<Error>;

export interface ErrorResponse {
  errors?: Error[] | null;
}

export const getUserPermission = (): Promise<AxiosResponse> => {
  const url = "/users/permissions";
  return api.get(url);
};

export const useGetUserPermission = (
  options?: Omit<UseQueryOptions<any, any, any, any>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["UserPermission"],
    queryFn: () => getUserPermission(),
    enabled: options?.enabled ?? true,
    ...options,
  });
};

